import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { compose, withHandlers } from 'recompose';
import { WithTranslation, withTranslation } from 'react-i18next';

import { WithStyles, withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { Credentials } from '@store/types';
import { login } from '@store/auth/auth.actions';
import { VTheme } from '@style/theme';
import { TextField } from '@components/Form';
import { Forms } from '@store/forms';

export interface LoginFormProps {
  isLoading: boolean;
}

interface LoginFormPrivateProps extends LoginFormProps, WithStyles, WithTranslation {
  handleSubmit: () => void;
  loginRequest: typeof login.started;
}

const styles = (theme: VTheme) => ({
  container: {
    display: 'flex',
  },
  button: {
    marginLeft: theme.spacing(),
    marginTop: theme.spacing(2),
  },
  textField: {
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
    width: 250,
  },
});

const LoginForm: React.FunctionComponent<LoginFormPrivateProps> = ({ t, classes, handleSubmit, isLoading }) => {
  return (
    <div className={classes.container}>
      <form onSubmit={handleSubmit}>
        <Field component={TextField} className={classes.textField} name="username" label={'Username'} required={true} />
        <Field
          component={TextField}
          className={classes.textField}
          name="password"
          label={'Password'}
          type="password"
          required={true}
        />
        <Button variant="outlined" disabled={isLoading} color="primary" className={classes.button} type={'submit'}>
          {isLoading ? t('app:wait') : t('app:login')}
        </Button>
      </form>
    </div>
  );
};

export default compose<LoginFormPrivateProps, LoginFormProps>(
  withStyles(styles),
  withTranslation(),
  withHandlers({
    onSubmit: ({ loginRequest }: LoginFormPrivateProps) => (creds: Credentials) => {
      loginRequest(creds);
    },
  }),
  reduxForm({ form: Forms.login }),
)(LoginForm);
